import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_CONFIG } from '../../aws-config';
import './AdminRegisterPage.css';

const AdminRegisterPage: React.FC = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ displayName: '', email: '', password: '', confirmPassword: '', adminKey: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const set = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (form.password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_CONFIG.baseURL}/admin/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: form.email,
          username: form.displayName,
          password: form.password,
          adminKey: form.adminKey,
        }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        setError(data.message || 'Registration failed.');
        setLoading(false);
        return;
      }
      setSuccess(true);
      setTimeout(() => navigate('/admin-login'), 2500);
    } catch {
      setError('Network error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="ar-page">
      <div className="ar-card">
        <div className="ar-header">
          <div className="ar-icon">🛡️</div>
          <h1 className="ar-title">Admin Registration</h1>
          <p className="ar-subtitle">Create a new administrator account</p>
        </div>

        {success ? (
          <div className="ar-success">
            <div className="ar-success-icon">✓</div>
            <p>Account created successfully!</p>
            <p className="ar-success-sub">Redirecting to admin login…</p>
          </div>
        ) : (
          <form className="ar-form" onSubmit={handleSubmit}>
            <div className="ar-field">
              <label className="ar-label">Display Name</label>
              <input className="ar-input" type="text" value={form.displayName} onChange={set('displayName')} placeholder="Admin Name" required autoFocus />
            </div>
            <div className="ar-field">
              <label className="ar-label">Email</label>
              <input className="ar-input" type="email" value={form.email} onChange={set('email')} placeholder="admin@example.com" required />
            </div>
            <div className="ar-row">
              <div className="ar-field">
                <label className="ar-label">Password</label>
                <input className="ar-input" type="password" value={form.password} onChange={set('password')} placeholder="••••••••" required />
              </div>
              <div className="ar-field">
                <label className="ar-label">Confirm Password</label>
                <input className="ar-input" type="password" value={form.confirmPassword} onChange={set('confirmPassword')} placeholder="••••••••" required />
              </div>
            </div>
            <div className="ar-field">
              <label className="ar-label">Admin Registration Key</label>
              <input className="ar-input" type="password" value={form.adminKey} onChange={set('adminKey')} placeholder="Enter the admin key provided by your super admin" required />
            </div>
            {error && <div className="ar-error">{error}</div>}
            <button className="ar-btn" type="submit" disabled={loading}>
              {loading ? 'Creating Account…' : 'Create Admin Account'}
            </button>
          </form>
        )}

        <div className="ar-footer">
          <a className="ar-link" href="/admin-login">Already have an account? Sign in</a>
          <a className="ar-back" href="/">← Back to main site</a>
        </div>
      </div>
    </div>
  );
};

export default AdminRegisterPage;
